import type { HelpFile } from '../../types/help'
import { CompareGrantsTestIds } from '../../../testids/CompareGrantsTestIds'

export const compareGrantsHelp: HelpFile = {
  docPage: '/docs/analytics/compare-grants',
  texts: {
    [CompareGrantsTestIds.cardTitleSelectIdentities]:
      'Zwei Identitäten (A und B) auswählen, deren effektive Zugriffsrechte gegenübergestellt werden sollen.',
    [CompareGrantsTestIds.comboboxIdentityA]:
      'Erste Identität für den Vergleich suchen und auswählen.',
    [CompareGrantsTestIds.comboboxIdentityB]:
      'Zweite Identität suchen und auswählen, die mit Identität A verglichen wird.',
    [CompareGrantsTestIds.cardTitleCommonGrants]:
      'Berechtigungen, die beide Identitäten besitzen — hilfreich für die Erkennung gemeinsamer Basisrechte.',
    [CompareGrantsTestIds.cardTitleCommonCount]: null,
    [CompareGrantsTestIds.cardTitleOnlyInA]:
      'Berechtigungen, die nur Identität A hat — der Zugriff, der B im Vergleich zu A fehlt.',
    [CompareGrantsTestIds.cardTitleOnlyInACount]: null,
    [CompareGrantsTestIds.cardTitleOnlyInB]:
      'Berechtigungen, die nur Identität B hat — der Zugriff, der A im Vergleich zu B fehlt.',
    [CompareGrantsTestIds.cardTitleOnlyInBCount]: null,
    [CompareGrantsTestIds.colCommonTargetSystem]: null,
    [CompareGrantsTestIds.colCommonEnforcementObject]: null,
    [CompareGrantsTestIds.colCommonOperation]: null,
    [CompareGrantsTestIds.colCommonValidUntil]:
      'Ablauf der gemeinsamen Berechtigung — leer bedeutet unbefristet.',
    [CompareGrantsTestIds.colOnlyATargetSystem]: null,
    [CompareGrantsTestIds.colOnlyAEnforcementObject]: null,
    [CompareGrantsTestIds.colOnlyAOperation]: null,
    [CompareGrantsTestIds.colOnlyAValidUntil]:
      'Ablauf der nur von Identität A gehaltenen Berechtigung — leer bedeutet unbefristet.',
    [CompareGrantsTestIds.colOnlyBTargetSystem]: null,
    [CompareGrantsTestIds.colOnlyBEnforcementObject]: null,
    [CompareGrantsTestIds.colOnlyBOperation]: null,
    [CompareGrantsTestIds.colOnlyBValidUntil]:
      'Ablauf der nur von Identität B gehaltenen Berechtigung — leer bedeutet unbefristet.',
  },
}
